import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Location } from '@angular/common';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
   
})
export class HeaderComponent implements OnInit {
    location: any;
    styleContainer: any;

    constructor(
        private router: Router,
        location: Location
    ) { }

    ngOnInit() {
        this.router.events
            .subscribe((event) => {
                if (event instanceof NavigationEnd) {
                    this.location = this.router.url;
                    if (this.location === '/home-two' || this.location === '/home-three' || this.location === '/home-four') {
                        this.styleContainer = 'container-fluid';
                    } else {
                        this.styleContainer = 'container';
                    }
                }
            });
    }


    activeDropdown: string | null = null;

    toggleDropdown(dropdown: string): void {
        this.activeDropdown =
            this.activeDropdown === dropdown ? null : dropdown;
    }

    closeMobileMenu(): void {
        this.activeDropdown = null;

        const navbar = document.getElementById('navbarSupportedContent');

        if (navbar?.classList.contains('show')) {
            navbar.classList.remove('show');
        }
    }
}
